var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex h-10"},_vm._l((_vm.tabNames),function(tab){return _c('button',{key:tab,staticClass:"border-b-4 select-none cursor-pointer font-semibold transition-colors duration-200 px-4",class:[
      _vm.isActive(tab)
        ? 'border-lagon-500 text-lagon-700'
        : 'border-transparent text-gray-700 hover:text-gray-900',
      _vm.tabsClass ],on:{"click":function($event){return _vm.$emit('input', tab)}}},[_vm._v("\n    "+_vm._s(tab[0].toUpperCase() + tab.slice(1))+"\n  ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }